export interface IDiagnosesGroup {
  id: number;
  name: string;
  diagnoses: IDiagnosisItem[];
}

export interface IDiagnosisItem {
  id: string;
  name: string;
  description: string;
}

export interface IDiagnosesGroupItem {
  id: number;
  name: string;
}

export interface IDiagnosesGroupsListRequest {
  search: string;
  skip: number;
  take: number;
}

export interface IDiagnosesGroupCreate {
  name: string;
  diagnosesIds: string[];
}

export enum DiagnosesSearchValueType {
  ICD10 = 'ICD10',
  Groups = 'Groups',
}
